import styled from '@emotion/styled';
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import type { FunctionComponent } from 'react';

import { ToolbarPlugin } from '~/ui/core/rich-editor/ToolbarPlugin';

import { RichEditorTranscribeButton } from './RichEditorTranscribeButton';

type RichEditorToolbarWithTranscribeProps = {
    readonly disabled?: boolean;
};

const ToolbarContainer = styled.div(({ theme }) => ({
    alignItems: 'center',
    backgroundColor: theme.colors.gray[50],
    border: `1px solid ${theme.colors.gray[400]}`,
    borderRadius: theme.spacing.xl,
    display: 'flex',
    gap: theme.spacing.xs,
    left: '50%',
    margin: '0 auto',
    padding: theme.spacing.xxs,
    position: 'absolute',
    transform: 'translateX(-50%) translateY(-130%)',
    zIndex: 999,
}));

const Separator = styled.div(({ theme }) => ({
    backgroundColor: theme.colors.gray[300],
    height: '1.5rem',
    marginLeft: theme.spacing.xs,
    marginRight: theme.spacing.xs,
    width: '1px',
}));

export const RichEditorToolbarWithTranscribe: FunctionComponent<RichEditorToolbarWithTranscribeProps> = ({
    disabled = false,
}) => {
    const [editor] = useLexicalComposerContext();

    return (
        <ToolbarContainer id="toolbar">
            <ToolbarPlugin disabled={disabled} />
            <Separator />
            <RichEditorTranscribeButton disabled={disabled} editor={editor} />
        </ToolbarContainer>
    );
};
